<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <v-icon class="small-icon">{{ bookingTypeIcon(booking) }}</v-icon>
        <span v-if="showWaitingTimeIndicators(booking)">
          <v-icon class="small-icon">mdi-clock</v-icon>
        </span>
        <v-icon class="small-icon" v-if="bookingAttributesToShow && bookingAttributesToShow.includes('offer_booking_publically') && booking.offer_booking_publically">
          mdi-alpha-b-circle
        </v-icon>
        <!-- <p
          style="display: inline;"
          class="small-text"
          v-if="booking.room_number != '' && booking.room_number != null"
        >{{booking.room_number}}&nbsp;&nbsp;</p>-->
        <div style="display: inline" class="blink-me">
          <v-icon
            color="red"
            class="small-icon blink-me"
            v-if="hasCardPaymentFailure(booking) == true"
            >payment</v-icon
          >
        </div>
        <v-icon class="small-icon" v-if="booking.needs_disabled_access == true"
          >accessible</v-icon
        >
        <span v-if="isBookingFromMillers">MIL</span>
        <v-icon class="small-icon" v-if="booking.needs_pets == true"
          >pets</v-icon
        >
        <v-icon class="small-icon" v-if="booking.require_ppe == true"
          >coronavirus</v-icon
        >
        <v-icon
          class="small-icon"
          v-if="booking.flight_number != '' && booking.flight_number != null"
          >flight</v-icon
        >
        <v-icon
            class="small-icon"
            v-if="booking.flight_delay"
        >flight_land</v-icon
        >
        <v-icon class="small-icon" v-if="booking.meet_and_greet != false"
          >all_inclusive</v-icon
        >
        <v-icon class="small-icon" v-if="booking.premium != null && booking.premium == true"
          >stars</v-icon
        >
        <p
          style="display: inline"
          class="small-text"
          v-if="booking.needs_wide == true"
        >
          wide
        </p>
        <p
          style="display: inline; font-weight: bold; color: black"
          class="small-text blink_me"
          v-if="
            booking.manual_dispatch == true &&
            booking.state != null &&
            booking.state == 'booked'
          "
        >
          M
        </p>
<!--
         <span
             class="small-text"
             v-if="booking.luggage_count != null && booking.luggage_count != 0"
           >
          <v-icon small>mdi-bag-checked</v-icon>
          {{ booking.luggage_count }}
         </span>
-->
         <span
           class="small-text"
           v-if="booking.ride_type_name && booking.state == 'booked'"
         >
           <v-icon small>mdi-car-info</v-icon>
          {{ getRideTypeShortName(booking.ride_type_name) }}
        </span>
      </span>
     
    </template>
    <span>
      <ul>
        <li v-if="hasCardPaymentFailure(booking) == true">
          <p class="light-list-text">
            {{ getCardPaymentFailureText(booking) }}
          </p>
        </li>
        <li>
          <p class="light-list-text" v-if="booking.needs_wide == true">
            Needs Wide Vehicle
          </p>
        </li>
        <li v-if="booking.needs_disabled_access == true">
          <v-icon color="white" class="small-icon">accessible</v-icon>
          {{ "Disabled Access Required" }}
        </li>
        <li v-if="booking.needs_pets == true">
          <v-icon color="white" class="small-icon">pets</v-icon>
          {{ "Pet on Board" }}
        </li>
        <li v-if="booking.require_ppe == true">
          <v-icon color="white" class="small-icon">coronavirus</v-icon>
          {{ "Requires PPE Barrier" }}
        </li>
        <li v-if="booking.flight_number != '' && booking.flight_number != null">
          <v-icon color="white" class="small-icon">flight</v-icon>
          Flight: {{ booking.flight_number }}
        </li>
        <li v-if="booking.flight_delay">
          Flight Delay
        </li>
        <li v-if="booking.room_number != '' && booking.room_number != null">
          <v-icon color="white" class="small-icon">hotel</v-icon>
          Room: {{ booking.room_number }}
        </li>
        <li v-if="booking.meet_and_greet != false">
          <v-icon color="white" class="small-icon">all_inclusive</v-icon>
          {{ "Meet and Greet" }}
        </li>
        <li></li>
        <li v-if="booking.premium != false">
          <v-icon color="white" class="small-icon">stars</v-icon>
          {{ "Premium Vehicle" }}
        </li>
        <li v-if="booking.luggage != null && booking.luggage != 0">
          <v-icon color="white" class="small-icon">card_travel</v-icon>
          Luggage: {{ booking.luggage }}
        </li>
        <li v-if="booking.manual_dispatch == true">Manual Dispatch</li>
        <li v-if="booking.offer_booking_publically == true">BID</li>
        <li v-if="booking.preassigned_driver != null">
          Preassigned: {{ booking.preassigned_driver.name }}
        </li>
        <li>Booking Type: {{ booking.booking_type }}</li>
        <li v-if="booking.luggage_count">Luggage: {{ booking.luggage_count }}</li>
        <li v-if="booking.ride_type_name">Ride Type: {{ booking.ride_type_name }}</li>
        <li v-if="showWaitingTimeIndicators(booking)">Waiting Time: {{ booking.waiting_time.waiting_time }} mins</li>
        <li v-if="showWaitingTimeIndicators(booking)">Waiting Time Charges: &pound;{{ getWaitingTimeCharges(booking.waiting_time) }}</li>
        <li v-if="showWaitingTimeIndicators(booking) && booking.waiting_time_will_kick_in">Waiting Time Kickin : {{ booking.waiting_time_will_kick_in }} mins</li>
      </ul>
    </span>
  </v-tooltip>
</template>

<script>
import moment from 'moment'

export default {
  name: "AttributesForBookingCell",
  props: {
    booking: Object,
    bookingAttributesToShow: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      rideTypeDictionary : {
        "myride" : "MR",
        "myride+" : "MR+",
        "platinum" : "PT"
      }
    }
  },
  mounted: function () {},
  computed: {
    waitingTimeKickIn () {
      if(moment(this.bookingForm.booking.pickup_date + " " + this.bookingForm.booking.pickup_time,
        "YYYY-MM-DD HH:mm").isBefore(moment(this.bookingForm.booking.arrived_time,
        "YYYY-MM-DD HH:mm"))) {
        
      }
      return null;
    },
    isBookingFromMillers() {
      if (this.booking && this.booking.operator && this.booking.operator.toLowerCase().includes("miller")) {
        console.log("millers is true")
        return true;
      }
      return false
    },
  },
  methods: {
    showWaitingTimeIndicators(booking) {
      return booking && booking.payment_type == 'card' && booking.waiting_time
    },
    getWaitingTimeCharges(waitTimes) {
      if (waitTimes && waitTimes.charges) {
        return Math.round(waitTimes.charges/100.00,2)
      }
      return 0.00
    },
    getRideTypeShortName(rideTypeName) {
      rideTypeName = rideTypeName.trim()
      if (this.rideTypeDictionary[rideTypeName.toLowerCase()] != undefined){
        return this.rideTypeDictionary[rideTypeName.toLowerCase()]
      } else {
        const firstLetters = rideTypeName
          .split(' ')
          .map(word => word[0])
          .join('');
        return firstLetters.toUpperCase();
      }
    },
    bookingTypeIcon: function (b) {
      if (b.booking_type == "app") {
        return "smartphone";
      } else if (b.booking_type == "phone") {
        return "local_phone";
      } else if (b.booking_type == "repeat") {
        return "repeat";
      } else if (b.booking_type == "website") {
        return "desktop_mac";
      } else if (b.booking_type == "flag_down") {
        return "emoji_people";
      } else if (b.booking_type == "kiosk") {
        return "storefront";
      }
    },
    hasCardPaymentFailure: function (b) {
      return (
        b.card_status != null &&
        (b.card_status === "pre-auth-fail" ||
          b.card_status === "failed" ||
          b.card_status === "card-payment-turned-off" ||
          b.card_status === "auth-required")
      );
    },
    getCardPaymentFailureText: function (b) {
      if (b.card_status_reason != null) {
        return b.card_status + ": " + b.card_status_reason;
      } else {
        return b.card_status;
      }
      return "Unknown";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.small-icon {
  font-size: 14px !important;
  padding-right: 3px;
  color: black;
}

.light-list-text {
  color: white !important;
  font-size: 12px !important;
}

.small-text {
  font-size: 10px !important;
  color: black;
}

.blink_me {
  animation: blinker 2s linear infinite !important;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>
